import { parseGermanDate } from './germanDate'

const zwei = (n: number) => String(n).padStart(2, '0')

function zeitstempel(s: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}T/.test(s)) return null
  const date = new Date(s)
  return Number.isNaN(date.getTime()) ? null : date
}

export function formatDatum(value: unknown): string {
  const s = (value == null ? '' : String(value)).trim()
  const date = zeitstempel(s)
  if (date) return `${zwei(date.getDate())}.${zwei(date.getMonth() + 1)}.${date.getFullYear()}`
  const p = parseGermanDate(s)
  return p ? `${zwei(p.d)}.${zwei(p.m)}.${p.y}` : s
}

export function vonAmVermerk(label: string, { von, am }: { von?: string | null; am: string }): string {
  const datum = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(
    new Date(am),
  )
  return von ? `${label} von ${von} am ${datum}` : `${label} am ${datum}`
}

export function formatZeitpunkt(value: unknown): string {
  const s = (value == null ? '' : String(value)).trim()
  const date = zeitstempel(s)
  return date ? `${formatDatum(s)}, ${zwei(date.getHours())}:${zwei(date.getMinutes())}` : formatDatum(s)
}

export function todayIso(): string {
  const d = new Date()
  return `${d.getFullYear()}-${zwei(d.getMonth() + 1)}-${zwei(d.getDate())}`
}

export function nowHhMm(): string {
  const d = new Date()
  return `${zwei(d.getHours())}:${zwei(d.getMinutes())}`
}
